import { render, staticRenderFns } from "./InputSelect.vue?vue&type=template&id=dcc0d6a6&scoped=true&"
import script from "./InputSelect.ts?vue&type=script&lang=ts&"
export * from "./InputSelect.ts?vue&type=script&lang=ts&"
import style0 from "./InputSelect.scss?vue&type=style&index=0&id=dcc0d6a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc0d6a6",
  null
  
)

export default component.exports